/* eslint-disable default-case */
import { createSlice } from '@reduxjs/toolkit';
import {
  activateChatbotLicenceThunk,
  getChatbotBusinessesAnalyticsThunk,
  getChatbotLicenceBusinessessThunk,
} from '../thunks/chatbotAnalyticsThunks';

export const chatbotAnalyticsSlice = createSlice({
  name: 'chatbotAnalytics',
  initialState: {
    isLoading: false,
    chatbotLicencess: [],
    selectedBusinessId: undefined,
    chatbotAnalytics: {}, // { [businessId]: analytics } // yritys kohtaset analytiikat
  },
  reducers: {
    selectChatbotAnalyticsBusinessId: (state, action) => {
      console.log('selectChatbotAnalyticsBusinessId');
      state.selectedBusinessId = action.payload;
    },
    unSelectChatbotAnalyticsBusinessId: (state, action) => {
      console.log('unSelectChatbotAnalyticsBusinessId');
      state.selectedBusinessId = undefined;
    },
  },
  extraReducers(builder) {
    builder
      // GET
      .addCase(getChatbotLicenceBusinessessThunk.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getChatbotLicenceBusinessessThunk.fulfilled, (state, action) => {
        const res = action.payload;
        console.log('getChatbotLicenceBusinessessThunk RESPONSE::');
        console.log(res);

        state.chatbotLicencess = res;

        state.isLoading = false;
      })
      .addCase(getChatbotLicenceBusinessessThunk.rejected, (state, action) => {
        state.isLoading = false;
      })

      // POST buy chatbot licence
      .addCase(activateChatbotLicenceThunk.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(activateChatbotLicenceThunk.fulfilled, (state, action) => {
        const res = action.payload;
        console.log('activateChatbotLicenceThunk RESPONSE::');
        console.log(res);
        state.chatbotLicencess.push(res);

        state.isLoading = false;
      })
      .addCase(activateChatbotLicenceThunk.rejected, (state, action) => {
        state.isLoading = false;
      })

      // GET businesses analytics
      .addCase(getChatbotBusinessesAnalyticsThunk.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(
        getChatbotBusinessesAnalyticsThunk.fulfilled,
        (state, action) => {
          const res = action.payload;

          if (res.length >= 1) {
            const business_id = res[0].business_id; // WE CAN DO THIS because query get api gets only given business ids analytics
            console.log(
              'SAATIIKO PARSITTUA BUSINESS ID chatbot analytics responsesta'
            );
            console.log(business_id);

            state.chatbotAnalytics[business_id] = res;
          }

          state.isLoading = false;
        }
      )
      .addCase(getChatbotBusinessesAnalyticsThunk.rejected, (state, action) => {
        state.isLoading = false;
      });
  },
});

// ACTIONS
export const {
  selectChatbotAnalyticsBusinessId,
  unSelectChatbotAnalyticsBusinessId,
} = chatbotAnalyticsSlice.actions;

// SELECTORS
export const getChatbotAnalyticsControlData = (state) => {
  const slice = state.chatbotAnalyticsSlice;

  const selectedBusinessesAnalyticsByUser =
    slice?.chatbotAnalytics[slice?.selectedBusinessId];

  return {
    isLoading: slice?.isLoading,
    chatbotLicencess: slice?.chatbotLicencess,
    selectedBusinessId: slice?.selectedBusinessId,
    chatbotAnalytics: selectedBusinessesAnalyticsByUser,
  };
};
